<template>

      <div class="item">

        <!-- <span class="num">{{item.total_views}} <p>האזנות</p></span> -->
        <span class="num" v-text="(num < 10 ? '0' : '') + num"></span>

        <div class="pic" :style="'background-image:url(' + item.pic_tumb + ')'">
          <a class="play_btn" @click="$emit('play', item)"><i class="fas fa-play"></i></a>
        </div>
        
        <div class="texts">
            <!-- <h3 v-text="item.artist.name"></h3> -->
            <h4 v-text="item.name"></h4>
        </div>
          
        <span class="duration show_in_desktop"><i class="far fa-clock"></i> {{item.total_time}}</span>
          <span class="date show_in_desktop" v-text="item.online_date_format"></span>
   <div class="share">
          <div class="icon" @click="$bus.$emit('share_url', 'Artist/37875466')"><i class="fas fa-share-alt"></i></div>
        </div>
        <div class="option show_in_desktop" @click="$bus.$emit('open_widget', item)"><img src="@/assets/to_lt.svg" style="height:35px;"><p>הצג לינקטון</p></div>
        <div class="remove"><a @click="$emit('remove')"><i class="fas fa-trash"></i></a></div>
     
      </div>
</template>
<style scoped lang="scss">
.item{
  .share{display: flex;padding: 25px;}
  .share{
    .icon{margin: 0 10px;font-size: 14px;border: 1px solid;padding: 0px;border-radius: 100%;line-height: 1px;cursor: pointer; width:30px; height: 30px; text-align: center; line-height: 30px;}
    .icon:hover{transform: scale(1.04);}
  }
  .texts{
    h4{color: #000 !important;padding-top: 25px;padding-right: 25px;}
  }
  .num{
    &{    font-size: 51px;padding-top: 19px;color: rgb(27, 27, 27) !important;}
    p{    font-size: 17px; margin-top: 4px;}
  }
  .option{
    &{text-align: center;padding-top: 9px;width: 10%;cursor: pointer;font-size: 16px;font-weight: 700;}
    .svg-inline--fa{    font-size: 35px;text-align: center;margin-bottom: -3px;}
  }

  .remove { display: flex; align-items: center; 
    a { color: #000; }
  }

  .pic { display: flex; justify-content: center; align-items: center;
    .play_btn { display: none !important; position: static !important; }
  }

  &:hover .pic .play_btn { display: block !important;}
}
.duration svg { font-size: 13px; opacity: 0.4;}
</style>

<script>
  
export default {
  props: ["item" ,"active","num"],
  data(){
    return {
    }
  },
  methods: {

  }
}
</script>